module.exports = __webpack_public_path__ + "static/media/YB5F12_6.efd08e4e.jpg";